<template>
    <div v-if="choices != null">
        <v-autocomplete
            :label="label"
            :items="choices"
            :value="value"
            :hint="hint"
            :persistent-hint="!!hint"
            clearable
            @input="$emit('input', $event)"
            @click:clear="$emit('input', null)"
        >
            <template #append-outer>
                <div class="d-flex align-center mt-3">
                    <m-icon-btn
                        v-if="allow_upload"
                        icon="mdi-plus-circle-outline"
                        icon_color="primary"
                        text="Upload image"
                        @click="onClickAdd"
                    />

                    <m-icon-btn
                        v-if="show_restore_button"
                        icon="mdi-restore"
                        text="Restore original image"
                        @click="onClickRestore"
                    />
                </div>
            </template>

            <template #selection="{ item }">
                <v-list-item-avatar
                    size="28"
                    class="mt-1 ml-1 mr-2 mb-1"
                    tile
                >
                    <img
                        :src="item.value"
                        alt=""
                        class="avatar-image"
                    >
                </v-list-item-avatar>

                <span>{{ item.text }}</span>
            </template>

            <template #item="{ item }">
                <v-list-item-avatar
                    size="36"
                    class="mt-1 ml-0 mr-4 mb-1"
                    tile
                >
                    <img
                        :src="item.value"
                        alt=""
                        class="avatar-image"
                    >
                </v-list-item-avatar>

                <span>{{ item.text }}</span>
            </template>
        </v-autocomplete>

        <m-edit-blobs-dialog
            ref="edit-blobs-dialog"
            v-on:ok="afterEditBlobsDialog($event)"
            :externally_visible="true"
            :allow_multiple="false"
            purpose="organization-logo"
            :title="add_dialog_title"
            :allow_media_assets="false"
            :organization_id="organization_id ?? $route.params.organization_id"
        />
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: {
        value: {
            type: String,
            default: function () { return null; }
        },

        allow_upload: {
            type: Boolean,
            default: function () { return true; }
        },

        organization_id: {
            type: String,
            default: function () { return null; }
        },

        label: {
            type: String,
            default: function () { return 'Logo Image'; }
        },

        add_dialog_title: {
            type: String,
            default: function () { return 'Add Image'; }
        },

        value_to_restore: {
            type: String,
            default: function () { return null; }
        },

        include_redchirp_stock_images: {
            type: Boolean,
            default: function () { return true; }
        },

        hint: {
            type: String,
            default: function () { return null; }
        },
    },

    data() {
        return {
            choices: null,
            original_value: null,
            show_restore_button: false,
        }
    },

    mounted() {
        this.update();
        this.original_value = this.value;
    },

    methods: {
        update() {
            this.$rc.rest({
                spinner: false,
                endpoint: 'GET: /api/v1/organizations/images/:organization_id',

                params: {
                    organization_id: this.organization_id ?? this.$route.params.organization_id,
                },

                on_success: (data) => {
                    this.choices = data.results;
                },

                on_error: 'Unable to get organization logos',
            });
        },

        onClickAdd() {
            this.$refs['edit-blobs-dialog'].showDialog();
        },

        onClickRestore() {
            this.show_restore_button = false;
            this.$emit('input', this.original_value);
        },

        afterEditBlobsDialog(results) {
            let orig = _.cloneDeep(this.choices).map(item => item.value);

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/organizations/images/:organization_id',

                'params': {
                    'organization_id': this.organization_id ?? this.$route.params.organization_id,
                },

                'on_success': (data) => {
                    this.choices = data.results;

                    let difference = data.results.map(item => item.value)
                        .filter(item => !orig.includes(item));


                    if (difference.length > 0) {
                        this.$emit('input', difference[0]);
                    }
                },

                'on_error': 'Unable to get organization logos',
            });
        },
    },

    watch: {
        value(newVal) {
            this.show_restore_button = newVal !== this.original_value;
        },
    },
}
</script>

<style lang="scss" scoped>
.avatar-image {
    object-fit: contain;
}

.restore_image_button {
    display: flex;
    align-items: center;
    margin-top: 14px;
}

:deep(.v-text-field) {
    align-items: center;
}

:deep(.v-messages__message) {
    padding-top: 6px;
    line-height: 1.2;
}
</style>